import React from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import ItemDetailView from "presentational/common/ItemDetailView";
import TXT from "presentational/common/multinational/TXT";
import { getImgUrl } from "lib/imageUrlHelper";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const MODAL_WIDTH = "100%";

const colorCss = config.css.color;
const commonCss = config.css.commonDevice;

const { maxWidthOfContentWithoutPadding, outerPaddingOfContent } =
  commonCss.itemDetail;

const css = {
  paper: {
    marginLeft: 0,
    marginRight: 0,
    width: MODAL_WIDTH,
    maxWidth: maxWidthOfContentWithoutPadding + outerPaddingOfContent * 2
  },
  contentComponent: { padding: outerPaddingOfContent }
};

ItemModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  itemInfo: PropTypes.shape({
    image: PropTypes.string.isRequired,
    itemHash: PropTypes.string.isRequired,
    gender: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    color: PropTypes.string,
    tag: PropTypes.string
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  disableButtons: PropTypes.bool,
  guestMode: PropTypes.bool,
  deleteMode: PropTypes.bool,
  displayDetailTooltip: PropTypes.bool,
  onDelete: PropTypes.func
};

ItemModalView.defaultProps = {
  color: "",
  tag: "",
  gender: null,
  disableButtons: false,
  guestMode: false,
  deleteMode: false,
  displayDetailTooltip: false
};

function ItemModalView(props) {
  const {
    open,
    itemInfo,
    onClose,
    disableButtons,
    guestMode,
    deleteMode,
    displayDetailTooltip,
    onDelete
  } = props;

  const handleDeleteClick = () => {
    onDelete(itemInfo);
  };

  const {
    firstBtnText,
    firstBtnFunc,
    secondBtnText,
    secondBtnFunc,
    secondBtnColor
  } = (() => {
    if (deleteMode) {
      return {
        firstBtnText: <TXT name="btnModal_cancel" />,
        firstBtnFunc: onClose,
        secondBtnText: <TXT name="btnModal_delete" />,
        secondBtnFunc: handleDeleteClick,
        secondBtnColor: colorCss.colorOfDanger
      };
    } else {
      return {
        firstBtnText: <TXT name="btnModal_close" />,
        firstBtnFunc: onClose,
        secondBtnText: null,
        secondBtnFunc: () => {},
        secondBtnColor: null
      };
    }
  })();

  return (
    <CommonModalView
      open={open}
      onClose={onClose}
      paperStyle={css.paper}
      contentStyle={css.contentComponent}
      contentComponent={
        <ItemDetailView
          mode={disableButtons ? "disableBtns" : guestMode ? "guest" : "normal"}
          displayDetailTooltip={displayDetailTooltip}
          imageSrc={getImgUrl("item", itemInfo.image)}
          category={itemInfo.category}
          brand={itemInfo.brand}
          color={itemInfo.color}
          tag={itemInfo.tag}
          gender={itemInfo.gender}
        />
      }
      firstButtonText={firstBtnText}
      firstButtonFunc={firstBtnFunc}
      secondButtonText={secondBtnText}
      secondButtonTextColor={secondBtnColor}
      secondButtonFunc={secondBtnFunc}
    />
  );
}

export default ItemModalView;
